import store from "../redux/store";
import { setAccessToken } from "../redux/slices/authSlice";
import { logoutUser, refreshAccessToken } from "../redux/actions/index";
import api from "./apiAuth"; // API bağlantısı

// Retry konfigürasyonu
const retryConfig = {
  retries: 3,
  retryDelay: (retryCount) => retryCount * 1000,
  shouldRetry: (error) => {
    return (
      error.code === "ECONNABORTED" ||
      error.code === "ETIMEDOUT" ||
      error.response?.status >= 500
    );
  },
};

// 🔹 Request Interceptor
api.interceptors.request.use(
  async (config) => {
    const accessToken = store.getState().auth.accessToken;
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    config.timeout = 15000; // 15 saniye timeout
    return config;
  },
  (error) => Promise.reject(error)
);

// 🔹 Response Interceptor with Queue
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (token) prom.resolve(token);
    else prom.reject(error);
  });
  failedQueue = [];
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Retry mekanizması
    if (retryConfig.shouldRetry(error)) {
      originalRequest.retryCount = (originalRequest.retryCount || 0) + 1;

      if (originalRequest.retryCount <= retryConfig.retries) {
        const delay = retryConfig.retryDelay(originalRequest.retryCount);
        await new Promise((resolve) => setTimeout(resolve, delay));
        return api(originalRequest);
      }
    }

    // 401 hatası ve token yenileme
    if (error.response?.status === 401 && !originalRequest._retry) {
      // Login endpoint'i için özel kontrol
      if (originalRequest.url.includes("/auth/login")) {
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return api(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      isRefreshing = true;
      try {
        const { accessToken } = await store
          .dispatch(refreshAccessToken())
          .unwrap();
        if (!accessToken) throw new Error("Yeni access token alınamadı.");

        store.dispatch(setAccessToken(accessToken));
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        processQueue(null, accessToken);
        return api(originalRequest);
      } catch (err) {
        processQueue(err);
        store.dispatch(logoutUser());
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);

// apiWithCookies için de aynı retry mekanizmasını ekle
api.interceptors.request.use(
  (config) => {
    config.timeout = 15000;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (retryConfig.shouldRetry(error)) {
      originalRequest.retryCount = (originalRequest.retryCount || 0) + 1;

      if (originalRequest.retryCount <= retryConfig.retries) {
        const delay = retryConfig.retryDelay(originalRequest.retryCount);
        await new Promise((resolve) => setTimeout(resolve, delay));
        return api(originalRequest);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
